<template>
  <!-- 业绩详情页-个人 -->
  <div class="talents">
    <div class="talents_details">
      <div class="talents_details_content">
        <div class="talents_details_content_left">
          <div class="talents_details_content_left_titleBox">
            <div class="pic">
              <img src="@/assets/public/team-logo.png" alt="" />
            </div>
            <div class="left_box">
              <div class="title">
                <div class="text">{{ messageData.teamName }}</div>
                <div class="item_tag">
                  <span class="tagItem" v-if="messageData.teamTypeName">{{
                    messageData.teamTypeName
                  }}</span>
                </div>
              </div>
              <div class="imgIcon">
                <img src="@/assets/redesignImg/person.png" alt />
                <img src="@/assets/redesignImg/phone.png" alt />
                <img src="@/assets/redesignImg/shophome.png" alt />
              </div>
              <el-row :gutter="20" class="itemRow">
                <el-col :span="12">
                  <div class="item_text single_hide">
                    <span>联系人:</span>
                    <span class="item_data color3">{{
                      messageData.contact ? messageData.contact : ""
                    }}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="item_text single_hide">
                    <span>
                      联系电话:
                      <span v-if="showpNumber">{{
                        messageData.phoneNumber
                      }}</span>
                      <span v-else>{{
                        ShowPhone(messageData.phoneNumber)
                      }}</span>
                      <span
                        style="color:#0286DF;marginLeft:10px"
                        class="showText"
                        v-if="!showpNumber"
                        @click="ShowPhoneNumber"
                      >查看完整号码</span
                      >
                    </span>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20" class="itemRow">
                <el-col :span="12">
                  <div class="item_text single_hide">
                    <span>劳务人数:</span>
                    <span>{{
                      messageData.teamSize ? messageData.teamSize + "人" : ""
                    }}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="item_text single_hide">
                    <span>所在地区:</span>
                    <span>{{ messageData.provinceName }}</span>
                    <span
                      @click="showMap"
                      style="marginLeft:20px;cursor:pointer;"
                      v-if="messageData.longitude && messageData.latitude"
                    >
                      <img src="@/assets/public/map.jpg" alt />
                    </span>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20" class="itemRow">
                <el-col :span="12">
                  <div class="item_text single_hide">
                    <span>主营业务:</span>
                    <span>{{ ChangeStringBus(messageData) }}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="item_text single_hide">
                    <span>服务地区:</span>
                    <span
                      v-for="(item, index) in messageData.serviceAreas"
                      :key="index"
                    >{{ item.name }}</span
                    >
                  </div>
                </el-col>
              </el-row>
              <!-- <div class="item">
                <span style="marginRight:30px"
                  >联系人：{{ messageData.contact }}</span
                >
                <span>
                  联系电话：
                  <span v-if="showpNumber">{{ messageData.phoneNumber }}</span>
                  <span v-else>{{ ShowPhone(messageData.phoneNumber) }}</span>
                  <span
                    class="showText"
                    v-if="!showpNumber"
                    @click="ShowPhoneNumber"
                    >查看完整号码</span
                  >
                </span>

                <div v-show="messageData.teamSize" style="marginLeft:30px;">
                  <span>团队人数：</span>
                  <span>{{ messageData.teamSize }}</span>
                </div>
                <div>
                  <span>所在地区：</span>
                  <span>{{ messageData.provinceName }}</span>
                  <span
                    @click="showMap"
                    style="marginLeft:20px;cursor:pointer;"
                    v-if="messageData.longitude && messageData.latitude"
                  >
                    <img src="@/assets/public/map.jpg" alt />
                  </span>
                </div>
              </div> -->
              <!-- <div class="item">
                <div class="flex-item">
                  <span>服务地区：</span>
                  <span
                    v-for="(item, index) in messageData.serviceAreas"
                    :key="index"
                    >{{ item.name }}</span
                  >
                </div>
              </div>
              <div class="itemBottom">
                <div>
                  <span style="width:90px">主营业务：</span>
                  <span>{{ ChangeStringBus(messageData) }}</span>
                </div>
              </div> -->
              <div class="left-footer">
                <div class="btn-item" @click="inByLetDialogClick">
                  <img src="@/assets/public/hanxun.png" alt="" />
                  函询
                </div>
                <div class="btn-item" @click="OnlineConsulting">
                  <img src="@/assets/public/jiaoliu.png" alt />
                  交流
                </div>
                <div class="btn-item" @click="invitation">
                  <img src="@/assets/public/yaoqing.png" alt />
                  邀请
                </div>
                <div class="btn-item" @click="join">
                  <img src="@/assets/public/jiameng.png" alt />
                  加盟
                </div>
              </div>
            </div>
            <div class="right_box">
              <div class="attention-wrap">
                <span class="show" v-show="messageData.createTime"
                >发布时间： {{ messageData.createTime | formatDate }}</span
                >
                <span
                  @click="clickAttention(true)"
                  v-if="!isAttention"
                  class="attention-item"
                >
                  <img src="@/assets/attention0.png" height="14" width="15" />
                  <span>关注</span>
                </span>
                <span
                  @click="clickAttention(false)"
                  v-else
                  class="attention-item"
                >
                  <img src="@/assets/attention1.png" height="14" width="16" />
                  <span>已关注</span>
                </span>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="dataList bjxqbox">
        <!-- <div class="titlegzbj">工队业绩</div> -->
        <div class="content-boxbb">
          <div class="title-logo">
            <div class="cb"></div>
            <span>业绩详情</span>
          </div>
          <el-row class="row-bb">
            <el-col :span="8">
              <p>项目名称：{{ YJinfo.projectName }}</p>
            </el-col>
            <el-col :span="8">
              <p>业主单位：{{ YJinfo.owner }}</p>
            </el-col>
          </el-row>
          <el-row class="row-bb">
            <el-col :span="8">
              <p>
                工程地点：{{ YJinfo.provinceName }}{{ YJinfo.cityName
                }}{{ YJinfo.projectPlace }}
              </p>
            </el-col>
            <el-col :span="8">
              <p>
                开工/竣工时间：{{ dateFormat(YJinfo.startTime) }}~{{
                  dateFormat(YJinfo.endTime)
                }}
              </p>
            </el-col>
          </el-row>
          <el-row class="row-bb">
            <el-col :span="8">
              <p>证明人：{{ YJinfo.contact }}</p>
            </el-col>
            <el-col :span="8">
              <p>联系电话：{{ YJinfo.contactPhone }}</p>
            </el-col>
          </el-row>
          <el-row class="row-bb">
            <el-col :span="20">
              <div class="item_text">
                <span>项目描述：</span>
                <span>{{ YJinfo.projectDescribe }}</span>
              </div>
            </el-col>
            <!-- <el-col :span="20">
              <div class="item_text">
                <span>施工内容: </span>
                <span>{{ YJinfo.construction }}</span>
              </div>
            </el-col> -->
          </el-row>
          <el-row class="row-bb">
            <el-col :span="20">
              <div class="item_text">
                <span>施工内容: </span>
                <span>{{ YJinfo.construction }}</span>
              </div>
            </el-col>
          </el-row>
          <div class="title-logo" v-if="YJinfo.evidences.length > 0">
            <div class="cb"></div>
            <span>证明材料</span>
          </div>
          <el-row :gutter="20">
            <el-col
              :span="5"
              :key="index"
              v-for="(item, index) in YJinfo.evidences"
            >
              <el-image
                v-if="item.type == '1'"
                style="width: 216px; height: 140px"
                :src="item.url"
                :preview-src-list="[item.url]"
              ></el-image>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col
              :span="5"
              :key="index"
              v-for="(item, index) in YJinfo.evidences"
            >
              <video
                v-if="item.type == '2'"
                style="width:420px;height:270px"
                :src="item.url"
                :key="index + 1"
                class="avatar"
                controls="controls"
              >
                您的浏览器不支持视频播放
              </video>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="recommendList">
        <div class="title">
          <div class="name">相关团队推荐</div>
          <div class="more" @click="More">查看更多</div>
        </div>
        <tableCard
          v-if="newSettledListData.length > 0"
          :teamList="newSettledListData"
          :loadingTrue="loadingTrue"
          :showFoldIcon="showFoldIcon"
          :showMoreIcon="showMoreIcon"
        ></tableCard>
        <BaseEmptyData v-else></BaseEmptyData>
      </div>
    </div>

    <el-dialog
      center
      title="地图显示"
      :visible.sync="dialogFormVisible"
      width="70%"
      :close-on-click-modal="false"
    >
      <span>
        <i class="el-icon-location-outline"></i>
        所在地区:{{ messageData.provinceName
        }}{{ messageData.cityName ? "/" + messageData.cityName : null }}
      </span>
      <mapdetail
        ref="childDataDt"
        :center="mapCenter"
        :position="mapPosition"
        :text="text"
      ></mapdetail>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogFormVisible = false"
        >关 闭</el-button
        >
      </div>
    </el-dialog>
    <!-- 函询弹框 -->
    <InByLetDialog
      :dialogVisible="inByLetDialogShow"
      :dialogType="1"
      @closeDialog="closeinDialog"
      @confirmDialog="confirminDialog"
    ></InByLetDialog>
  </div>
</template>

<script>
import axios from '@/http'
import { mapState } from 'vuex'
import { formatDate2, formatDate } from '@/filters'
import { apiResignAll } from '@/api/apiResignAll'
import localStorage from '@/storage/localStorage'
import cookie from '@/storage/cookies'
const ERR_OK = 200
export default {
  name: 'teamYJDetail',
  props: {},
  data () {
    return {
      /** @name 工队no和业绩no */
      userNos: '',
      pNo: '',

      /** @name 详情信息 */
      YJinfo: {},
      inByLetDialogShow: false,
      dialogFormVisible: false,
      mapCenter: [],
      mapPosition: [],
      teamSizeOption: [],
      userNo: '',
      companyNo: '',
      // markName:'',
      text: {
        text: '',
        offset: [0, -50]
      },

      ShowMoreText: true,
      isHtml: false,
      showpNumber: false,
      // 当前标志
      InfoNo: null,
      // 主题信息
      UserInfo: {},
      // 详情信息
      messageData: {
        besinessScope: '',
        contact: '',
        id: 3,
        no: '',
        phoneNumber: '',
        serviceArea: '',
        teamIntroduce: '',
        teamName: '',
        teamSize: 0,
        teamStatus: null,
        companyId: null,
        scopes: []
      },
      teamInfo: {},
      phone: '',
      title: {
        name: '',
        updateTime: null
      },

      IsPerson: true,
      constructionTeamData: {},
      teamTypeData: [],
      teamSkillsData: [],
      rollScroll: false,
      VideoParam: {
        page: 1,
        limit: 10
      },

      offernoTextData: false,

      loadingTrue: false,
      noTextData: false,
      performanceParam: {
        page: 1,
        limit: 10,
        companyNo: '',
        userNo: ''
      },

      newSettledListData: [],
      // 是否关注
      isAttention: false,
      // 防止重复提交
      isRepeatSubmit: false
    }
  },
  computed: {
    ...mapState({
      userId: state => state.user.no
    }),
    isLogin: function () {
      return this.$store.state.token
    }
  },
  components: {
    InByLetDialog: () => import('@/components/public/InquiryLetterDialog'), // 函询弹框

    mapdetail: () => import('@/components/public/components/mapDetail'),
    tableCard: () => import('@/views/Home/AllComponents/HomeTeamList/tableCard.vue'), // 卡片列表
    BaseEmptyData: () => import('@/components/public/BaseEmptyData')
  },

  created () {},
  mounted () {
    this.userNos = this.$route.query.userNo ? this.$route.query.userNo : ''
    this.pNo = this.$route.query.pNo ? this.$route.query.pNo : ''
    if (cookie.cookieRead('token')) {
      // this.userFocus();
    }
    // this.TeamInfoDetail()
    // this.getOfferDetail();/
    this.getYJDetail()
  },
  methods: {
    /** @name 邀请 */
    invitation () {
      this.$message.error('该班组工队暂未认证企业,暂时无法邀请!')
    },
    /** @name 加盟 */
    join () {
      this.$message.error('该班组工队暂未认证企业,暂时无法加盟!')
    },
    // 时间格式转化
    timeToString (timestamp) {
      const d = new Date(timestamp * 1000) // 根据时间戳生成的时间对象
      const date =
        d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
      return date
    },
    formatDate,
    /** @name 函询按钮点击方法 */
    async inByLetDialogClick () {
      if (this.$store.state.loginType) {
        if (this.messageData.userNo === this.userId) {
          this.$message.error('不能给自己发送函询！')
          return
        }
        this.inByLetDialogShow = true
      } else {
        this.loginIndex()
      }
    },
    /** @name 函询关闭 */
    closeinDialog (val) {
      this.inByLetDialogShow = val
    },
    /** @name 函询提交 */
    async confirminDialog (obj) {
      this.$set(obj, 'teamCompamyNo', this.companyNo)
      this.$set(obj, 'teamUserNo', this.userNo)
      this.$set(obj, 'markName', this.messageData.teamName)
      this.$set(obj, 'markType', 1)
      let params = { markId: this.$route.params.id, ...obj }
      let res = await apiResignAll.getSaveForBid(params)
      if (res.data.code === ERR_OK) {
        this.$message.success('提交成功')
        this.inByLetDialogShow = false
      } else {
        this.$message.error('提交失败')
      }
    },
    // 点击查看地图
    showMap () {
      this.dialogFormVisible = true
    },

    ChangeStringRec (data) {
      //
      const array = []
      if (data.businessScopes && data.businessScopes.length > 0) {
        data.businessScopes.map(item => {
          const secArray = []
          if (item.firstCategoryName) {
            secArray.push(item.firstCategoryName)
          }
          if (item.secondCategoryName) {
            secArray.push(item.secondCategoryName)
          }
          if (item.thirdCategoryName) {
            secArray.push(item.thirdCategoryName)
          }
          array.push(secArray.join('/'))
        })
      }
      //
      return array.join('；')
      // const stringF = data.firstCategoryName ? data.firstCategoryName : "";
      // const stringS = data.secondCategoryName
      //   ? `/${data.secondCategoryName}`
      //   : "";
      // const stringT = data.thirdCategoryName
      //   ? `/${data.thirdCategoryName}`
      //   : "";
      // return `${stringF} ${stringS}${stringT} `;
    },
    /** @name 过滤主营业务数据 */
    ChangeStringBus (data) {
      //
      const array = []
      if (data.businessScopes && data.businessScopes.length > 0) {
        data.businessScopes.map(item => {
          const secArray = []
          if (item.firstCategoryName) {
            secArray.push(item.firstCategoryName)
          }
          if (item.secondCategoryName) {
            secArray.push(item.secondCategoryName)
          }
          if (item.thirdCategoryName) {
            secArray.push(item.thirdCategoryName)
          }
          if (item.fourCategoryName) {
            secArray.push(item.fourCategoryName)
          }
          if (item.fifthCategoryName) {
            secArray.push(item.fifthCategoryName)
          }
          if (item.sixthCategoryName) {
            secArray.push(item.sixthCategoryName)
          }
          array.push(secArray.join('/'))
        })
      }
      //
      return array.join('；')
    },
    /** @name 过滤工程分类 */
    ChangeStringFive (data) {
      const array = []
      const secArray = []
      if (data.firstCategoryName) {
        secArray.push(data.firstCategoryName)
      }
      if (data.secondCategoryName) {
        secArray.push(data.secondCategoryName)
      }
      if (data.thirdCategoryName) {
        secArray.push(data.thirdCategoryName)
      }
      if (data.fourCategoryName) {
        secArray.push(data.fourCategoryName)
      }
      if (data.fifthCategoryName) {
        secArray.push(data.fifthCategoryName)
      }
      if (data.sixthCategoryName) {
        secArray.push(data.sixthCategoryName)
      }
      array.push(secArray.join('/'))
      //
      return array.join('；')
    },

    /** @name 进入企业网站 */
    enterpriseWeb () {
      let companyNo = this.$route.query.teamNo
      // this.getTeamInfoEdit(companyNo)
      // let routeUrl = process.env.VUE_APP_MATERIALSURL +  '/company/' + '?companyNo=' + companyNo + '&teamno=' + teamno + '&type=63'
      // window.open(routeUrl, '_blank')
    },
    /** @name 获取工队信息 */
    // getTeamInfoEdit (no) {
    //   apiResignAll.TeamInfoEdits(no).then(res => {
    //     if (res.data.code === 200) {
    //       this.teamInfo = res.data.data
    //       let teamno = this.teamInfo.no ? this.teamInfo.no : ''

    //       let routeUrl =
    //         process.env.VUE_APP_MATERIALSURL +
    //         '/company/' +
    //         '?companyNo=' +
    //         no +
    //         '&teamno=' +
    //         teamno +
    //         '&type=63'
    //       window.open(routeUrl, '_blank')
    //     }
    //   })
    // },
    GoDetila (id) {
      this.$router.push({
        path: `/teamDetails/${id}`
      })
      location.reload()
    },

    // 地址
    ChangeAddress (data) {
      var array = []
      if (data) {
        const objArray = JSON.parse(data) ? JSON.parse(data) : []
        //

        objArray.map(item => {
          array.push(item.name)
        })
      }
      //
      const string = array.join(',')
      return string
    },
    /** @name 获取业绩详情 */
    async getYJDetail () {
      let data = await axios.get(
        `/teamResults/detailTeamResults?no=${this.pNo}`
      )

      this.YJinfo = data.data.data
    },
    /** @name 获取推荐列表 */
    async newSettledList (id, companyNo, userNo) {
      const obj = {
        id,
        companyNo,
        userNo
      }
      let res = await apiResignAll.recommendList(obj)
      if (res.data.code === 200) {
        this.newSettledListData = res.data.data.slice(0, 4)
      }
    },
    // 查看更多
    More () {
      this.$store.commit('SET_INDEXKEY', 1)
      localStorage.set('indexKey', 1)
      this.$router.push('/teamList')
    },
    // 联系号码
    ShowPhone (phone) {
      if (phone && phone.length === 11) {
        const number = `${phone.slice(0, 3)}****${phone.slice(7, 11)}`
        return number
      }
    },

    /** @name 获取头部企业详情 */
    // async TeamInfoDetail () {
    //   let res = await apiResignAll.TeamInfoEdits('', this.userNos)
    //   if (res.data.code === 200) {
    //     Object.assign(this.messageData, res.data.data)
    //     //
    //     if (this.messageData.isFocus) {
    //       this.isAttention = true
    //     } else {
    //       this.isAttention = false
    //     }
    //     this.companyNo = this.messageData.companyNo
    //     this.userNo = this.messageData.userNo

    //     this.text.text =
    //       this.messageData.provinceName +
    //       (this.messageData.cityName ? '/' + this.messageData.cityName : null)
    //     let temp = [
    //       Number(this.messageData.longitude),
    //       Number(this.messageData.latitude)
    //     ]
    //     this.mapCenter = temp
    //     this.mapPosition.push(Number(temp[0]))
    //     this.mapPosition.push(Number(temp[1]))

    //     // 团队推荐
    //     let provinceNo = JSON.parse(cookie.cookieRead('area')).id
    //     this.newSettledList(provinceNo, '', '')
    //   }
    // },

    /** @name 获取工队人员数据 */
    async getTeamPerson (data) {
      let res = await apiResignAll.getTeamPerson(data)
      if (res.data.code === 200) {
        this.teamPersondataList = res.data.data.records
        if (this.teamPersondataList.length === 0) {
          this.noTextDataPerson = true
        } else {
          this.noTextDataPerson = false
        }
        this.$set(this.performanceParamPerson, 'total', res.data.data.total)
      }
    },

    /** @name 交流 */
    OnlineConsulting () {
      if (this.$store.state.loginType) {
        if (this.messageData.userNo === this.userId) {
          this.$message.error('不能和自己进行交流！')
          return
        }
        if (this.messageData.imId) {
          axios
            .get(
              process.env.VUE_APP_APITEAM +
                '/consultation?id=' +
                this.messageData.imId
            )
            .then(res => {
              if (res.data.code === ERR_OK) {
                this.$store.commit('SET_ISOPEN', true)
                this.$store.commit('SETTOUSER', res.data.data.imAccount)
              } else {
                this.$message.error(res.data.msg)
              }
            })

        } else {
          this.$message.error('服务升级中......')
        }
      } else {
        this.loginIndex()
      }
    },
    //  查看联系方式
    ShowPhoneNumber () {
      if (this.$store.state.loginType) {
        this.showpNumber = true
      } else {
        this.loginIndex()
      }
    },
    loginIndex () {
      let data = {
        callBack: function () {
          this.$store.dispatch('setUser')
          this.pushThis()
        }.bind(this)
      }
      this.$_login(data)
    },

    formatDate2,

    tel (telNum) {
      if (telNum) {
        let ary = telNum.split('')
        ary.splice(3, 4, '****')
        return ary.join('')
      }
      return ''
    },

    changeRollScroll (bol) {
      this.rollScroll = bol
    },

    menu () {},
    getShowTab () {},
    // 获取是否关注
    // userFocus() {
    //   let params = {
    //     no: this.$route.query.teamNo,
    //     type: 5,
    //   };
    //   apiHelp.userFocus(params).then((res) => {
    //     if (res.data && res.data.code === 200) {
    //       this.isAttention = res.data.data;
    //     }
    //   });
    // },

    /**
     * @name 点击关注
     * @type 工队1 工程2 工人3 */
    clickAttention (state) {
      let token = this.$store.state.token
      if (!token) {
        let data = {
          callBack: function () {
            this.$store.dispatch('setUser')
          }.bind(this)
        }
        this.$_login(data)
      } else {
        let no = this.$route.query.teamNo
        let type = 1
        if (this.isRepeatSubmit) return
        this.isRepeatSubmit = true
        apiResignAll
          .addAttention(no, type)
          .then(res => {
            if (res.data.code === 200) {
              this.isAttention = state
              if (state) {
                this.$message.success('关注成功')
              } else {
                this.$message.success('取消关注成功')
              }
            }
          })
          .finally(() => {
            this.isRepeatSubmit = false
          })
      }
    }
  }
  // watch: {
  //   isLogin: {
  //     handler: function (newVal, oldVal) {
  //       newVal && this.userFocus();
  //     },
  //   },
  // },
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import "~@/styles/variable.scss";

.bgdf {
  background: #dfe4ea;
}

.talents {
  width: 100%;
  background: #f5f5f5;
  display: flex;
  justify-content: center;
  align-items: flex-start;

  &_details {
    width: 1200px;
    background: #f5f5f5;

    &_content {
      width: 1200px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;

      &_left {
        width: 1200px;

        &_titleBox {
          width: 1200px;
          margin: 0 auto;
          margin-top: 10px;
          box-sizing: border-box;
          background-color: #ffffff;
          padding: 20px 20px;
          // box-shadow: 0 2px 5px #e1e1e1;
          border-radius: 3px;
          position: relative;
          border-bottom: 1px solid #e4e7ed;
          display: flex;
          .pic {
            width: 60px;
            height: 60px;
            border: 1px solid #e4e7ed;
            margin-right: 10px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .left_box {
            width: 918px;
            .itemRow {
              font-size: 14px;
              color: #666666;
              .item_text {
                padding: 5px 0;
              }
              .single_hide {
                // 单行隐藏
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .color6 {
                color: #666666;
              }
              .color3 {
                color: #333333;
              }
            }
            .item_tag {
              display: flex;
              align-items: center;
              .tagItem {
                height: 24px;
                line-height: 24px;
                background: rgba(2, 134, 223, 0.1);
                color: #0286df;
                font-size: 12px;
                display: inline-block;
                margin-right: 10px;
                padding: 0 5px;
                font-weight: normal;
              }
            }
            .imgIcon {
              text-align: left;
              line-height: 30px;
              img {
                display: inline-block;
                margin-right: 15px;
              }
            }
            .left-footer {
              display: flex;
              justify-content: center;
              align-items: center;
              line-height: 30px;
              margin-top: 20px;
              .btn-item {
                width: 85px;
                height: 30px;
                margin-right: 15px;
                font-size: 14px;
                border-radius: 5px;
                border: 1px solid #0286df;
                color: #0286df;
                text-align: center;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: space-evenly;
                &:hover {
                  color: #f7ab01;
                  border: 1px solid #f7ab01;
                }
                img {
                  display: inline-block;
                  width: 19px;
                  height: 15px;
                }
              }
            }
          }
          .right_box {
            width: 170px;
            .attention-wrap {
              flex: 1;
              display: flex;
              flex-direction: column;
              font-size: 14px;
              color: #666666;
              text-align: right;

              .attention-item {
                // margin-right: 30px;
                cursor: pointer;

                img {
                  margin-right: 10px;
                  position: relative;
                  top: 2px;
                }
              }
            }
            .imgIcon {
              flex: 5;
              text-align: right;
              line-height: 60px;
              img {
                display: inline-block;
                // width: 10px;
                // height: 10px;
                // border: 1px solid #999;
                margin-right: 15px;
              }
            }
            .isgeti {
              display: flex;
              justify-content: flex-end;
              .Inquirys {
                border: 1px solid #0099ff;
                border-radius: 5px;
                font-size: 14px;
                color: #0099ff;
                width: 40px;
                text-align: center;
                height: 30px;
                line-height: 30px;
                cursor: pointer;
                margin-right: 10px;
              }
              .zixun {
                border: 1px solid #0099ff;
                color: #0099ff;
                width: 90px;
                font-size: 14px;
                padding: 0px 5px;
                border-radius: 5px;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
              }
            }
            .footer {
              display: flex;
              justify-content: space-between;
              align-items: center;
              line-height: 30px;

              .textLeft {
                cursor: pointer;
                background: #0099ff;
                color: white;
                width: 80px;
                font-size: 14px;
                // text-align: center;
                padding: 0px 5px;
                border-radius: 5px;
                display: flex;
                justify-content: center;
                align-items: center;
                margin: 15px auto;
                margin: 15px 10px 15px auto;
              }
              .Inquiry {
                border: 1px solid #0099ff;
                border-radius: 5px;
                font-size: 14px;
                color: #0099ff;
                width: 40px;
                text-align: center;
                height: 30px;
                line-height: 30px;
                cursor: pointer;
              }

              .box {
                // margin: 10px 0 20px;
                border: 1px solid #0099ff;
                color: #0099ff;
                width: 90px;
                font-size: 14px;
                // text-align: center;
                padding: 0px 5px;
                border-radius: 5px;
                display: flex;
                justify-content: center;
                align-items: center;
                margin: 15px auto;
                margin: 15px 0px auto 10px;

                img {
                  margin-right: 5px;
                }

                cursor: pointer;
              }
            }
          }

          .title-icon {
            width: 240px;
            > span {
              background: #0286df;
              border-radius: 4px;
              font-size: 12px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: white;
              line-height: 21px;
              margin-left: 20px;
              padding: 0px 6px;
            }
          }

          .mark {
            font-size: 12px;
            font-family: Microsoft YaHei;
            font-weight: 300;
            color: rgba(255, 255, 255, 1);
            color: white;
            position: absolute;
            left: -20px;
            top: 8px;
            height: 0;
            width: 36px;
            line-height: 24px;
            border-bottom: 25px solid #409ee9;
            border-left: 25px solid transparent;
            border-right: 25px solid transparent;
            transform: rotate(-45deg);
          }

          .unmark {
            font-size: 12px;
            font-family: Microsoft YaHei;
            font-weight: 300;
            color: rgba(255, 255, 255, 1);
            color: white;
            position: absolute;
            left: -20px;
            top: 8px;
            height: 0;
            width: 36px;
            line-height: 24px;
            border-bottom: 25px solid #969696;
            border-left: 25px solid transparent;
            border-right: 25px solid transparent;
            transform: rotate(-45deg);
          }

          .title {
            // margin-bottom: 10px;
            display: flex;
            align-items: center;

            .text {
              font-size: 24px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: rgba(0, 0, 0, 1);
              line-height: 36px;
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              max-width: 800px;
              -webkit-box-orient: vertical;
            }

            .show {
              width: 100px;
              width: 140px;
              font-size: 12px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(150, 150, 150, 1);
              line-height: 30px;
            }

            .icon {
              border-radius: 5px;
              display: inline-block;
              padding: 10px 20px;
              background: #0099ff;
              color: white;
              padding: 5px 9px;
              font-size: 14px;
              margin-left: 15px;
            }
          }

          .item {
            font-size: 14px;
            display: flex;
            // justify-content: space-between;
            align-items: flex-start;
            line-height: 30px;
            .flex-item {
              display: flex;
              flex: 1;
              // > div {
              //   &:nth-child(1) {
              //     flex: 1;
              //   }
              //   // &:nth-child(2) {
              //   //   width: 900px;
              //   // }
              // }
            }
            span.showText {
              color: #0099ff;
              margin-left: 14px;
              text-decoration: underline;
              cursor: pointer;
            }
            & > div {
              margin-right: 20px;

              span {
                color: #666;

                &:nth-child(2) {
                  color: #333;
                }
              }
            }
          }

          .itemBottom {
            font-size: 14px;
            display: flex;
            align-items: flex-start;
            line-height: 30px;

            > div {
              // width: 600px;
              // text-overflow: -o-ellipsis-lastline;
              // overflow: hidden;
              // text-overflow: ellipsis;
              // display: -webkit-box;
              // -webkit-line-clamp: 2;
              // -webkit-box-orient: vertical;
              &:nth-child(1) {
                margin-right: 20px;
              }
              span {
                color: #666;

                &:nth-child(2) {
                  color: #333;
                }
              }
            }
          }
        }
      }

      &_right {
        width: 300px;
        margin-left: 20px;

        .PersonMessage {
          padding: 10px 20px;
          background: white;
          box-shadow: 0 2px 5px #e1e1e1;
          border-bottom: 1px solid #e4e7ed;
          margin-bottom: 10px;

          .name {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(0, 0, 0, 1);
            line-height: 36px;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            .describe {
              display: inline-block;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 200px;
            }

            .text {
              display: inline-block;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 200px;
            }

            .icon {
              display: inline-block;
              background: rgba(2, 134, 223, 1);
              border-radius: 4px;
              font-size: 12px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
              line-height: 21px;
              margin-left: 20px;
              padding: 0px 6px;
            }
          }

          .item {
            font-size: 14px;
            line-height: 30px;

            span.showText {
              color: #0099ff;
              margin-left: 14px;
              text-decoration: underline;
              cursor: pointer;
            }
          }

          .box {
            // margin: 10px 0 20px;
            border: 1px solid #0099ff;
            color: #0099ff;
            width: 80px;
            font-size: 14px;
            // text-align: center;
            padding: 8px 15px;
            border-radius: 5px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 15px auto;

            img {
              margin-right: 5px;
            }

            cursor: pointer;
          }
        }

        .EnterpriseMessage {
          padding: 10px 20px;
          background: white;
          box-shadow: 0 2px 5px #e1e1e1;
          border-bottom: 1px solid #e4e7ed;
          margin-bottom: 10px;

          .name {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(0, 0, 0, 1);
            line-height: 36px;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            .describe {
              display: inline-block;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 200px;
            }

            .text {
              display: inline-block;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 200px;
            }

            .icon {
              display: inline-block;
              background: rgba(2, 134, 223, 1);
              border-radius: 4px;
              font-size: 12px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
              line-height: 21px;
              margin-left: 20px;
              padding: 0px 6px;
            }
          }

          .imgIcon {
            img {
              display: inline-block;
              // width: 10px;
              // height: 10px;
              // border: 1px solid #999;
              margin-right: 15px;
            }
          }

          .item {
            font-size: 12px;
            line-height: 30px;

            span.showText {
              color: #0099ff;
              margin-left: 14px;
              text-decoration: underline;
              cursor: pointer;
            }
          }

          .footer {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .textLeft {
              cursor: pointer;
              background: #0099ff;
              color: white;
              width: 80px;
              font-size: 14px;
              // text-align: center;
              padding: 5px 5px;
              border-radius: 5px;
              display: flex;
              justify-content: center;
              align-items: center;
              margin: 15px auto;
              margin: 15px 10px 15px auto;
            }

            .box {
              // margin: 10px 0 20px;
              border: 1px solid #0099ff;
              color: #0099ff;
              width: 80px;
              font-size: 14px;
              // text-align: center;
              padding: 5px 5px;
              border-radius: 5px;
              display: flex;
              justify-content: center;
              align-items: center;
              margin: 15px auto;
              margin: 15px 15px auto 10px;

              img {
                margin-right: 5px;
              }

              cursor: pointer;
            }
          }
        }

        .ImgContent {
          width: 300px;
          height: 100px;
          // margin: 10px 0;
          margin-bottom: 10px;
          border: 1px solid #ccc;
        }
      }
    }
    .recommendList {
      background: white;
      margin-top: 10px;
      padding-top: 1px;
      .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-right: 20px;
        .name {
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #b79255;
          line-height: 30px;
          border-left: 3px solid #b79255;
          padding-left: 10px;
          margin: 20px 0 0 20px;
        }

        .more {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          line-height: 36px;
          cursor: pointer;
        }
      }
    }
    .dataList {
      padding: 20px;
      padding-top: 10px;
      background: white;
      margin: 30px 0px;
      margin-top: 10px;

      > .title {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .name {
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #B79255;
          line-height: 30px;
          border-left: 3px solid #B79255;
          padding-left: 10px;
        }

        .more {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          line-height: 36px;
          cursor: pointer;
        }
      }

      .itemList {
        padding: 10px 0px;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;

        .item {
          width: 273px;
          margin-right: 20px;
          border: 1px solid rgba(228, 230, 237, 1);
          font-size: 12px;
          color: #999;
          line-height: 30px;
          margin-bottom: 20px;
          &:nth-child(4n) {
            margin-right: 0px;
          }

          .top {
            padding: 10px 8px;
            // height: 90px;
            max-height: 90px;
            background: rgba(245, 247, 250, 1);

            .title {
              color: #000;
              font-size: 14px;
              font-weight: 300;
              cursor: pointer;

              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }
          }

          .bottom {
            padding: 10px 8px 0 8px;
            height: 90px;
            height: 70px;

            .type {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .business {
              line-height: 30px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }

          span {
            color: #333;
          }
        }
      }

      .noList {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 275px;
      }

      // .more {
      //   font-size: 12px;
      //   color: #999;
      //   text-align: right;
      //   margin: 10px 20px 30px;
      //   cursor: pointer;
      // }
    }
  }
}

.noData {
  width: 100%;
  background: #ffffff;
  padding-bottom: 40px;
  padding-top: 50px;
  border-radius: 0 0 4px 4px;
  border-top: none;
  box-sizing: border-box;

  .noDataImg {
    width: 177px;
    margin: 0 auto 15px;

    img {
      width: 100%;
    }
  }

  .noText {
    text-align: center;
    font-size: 18px;
    color: #333;
  }
}
.bjxqbox {
  .titlegzbj {
    height: 42px;
    width: 100%;
    font-size: 16px;
    font-weight: bold;
    border-bottom: 1px solid #e4e4e4;
    color: #0286df;
  }
  .content-boxbb {
    font-size: 14px;
    .title-logo {
      display: flex;
      width: 100%;
      align-items: center;
      padding-top: 10px;
      border-bottom: 1px dashed #E4E7ED;
      padding-bottom: 20px;
      margin-bottom: 20px;
      color: #B79255;
      .cb {
        height: 20px;
        border-radius: 1px;
        background-color: #B79255;
        width: 3px;
        margin-right: 10px;
      }
      span {
        font-size: 16px;
        font-weight: bold;
      }
    }
    .row-bb {
      margin-bottom: 20px;
      word-break: break-all;
      .single_hide {
        // 单行隐藏
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
</style>
<style lang="scss" rel="stylesheet/scss">
// 污染全局？？
.changeTootip {
  border: 1px solid #767676 !important;
  padding: 4px !important;
  font-size: 12px !important;
  font-family: Microsoft YaHei;
  // font-weight: 300 !important;
  color: rgba(102, 102, 102, 1) !important;
  border-radius: 2px !important;
  max-width: 1200px !important;
}
</style>
